import {
  isBothAxis,
  isBottomAxis,
  isLeftAxis,
  isRightAxis,
  isTopAxis,
  isXAxis,
  isYAxis,
} from './is-axis.js';
import type {
  XYChartAxisInternal,
  XYChartVisibleAxesConfig,
} from '../types/xy-chart-internals.js';

function shouldDisplayBothVertical(
  axes: XYChartAxisInternal[],
  topAxis: XYChartAxisInternal | undefined,
  bottomAxis: XYChartAxisInternal | undefined,
  bothAxis: XYChartAxisInternal | undefined,
) {
  if (!bothAxis) {
    return false;
  }

  const topIndex = axes.findIndex((axis) => isTopAxis(axis) && !axis.hidden);
  const bottomIndex = axes.findIndex(
    (axis) => isBottomAxis(axis) && !axis.hidden,
  );
  const bothIndex = axes.findIndex((axis) => isBothAxis(axis) && !axis.hidden);

  const nonDefined = !topAxis && !bottomAxis;

  return (
    (nonDefined && bothAxis) ||
    ((bothIndex < topIndex || topIndex === -1) &&
      (bothIndex < bottomIndex || bottomIndex === -1))
  );
}

function shouldDisplayBothHorizontal(
  axes: XYChartAxisInternal[],
  leftAxis: XYChartAxisInternal | undefined,
  rightAxis: XYChartAxisInternal | undefined,
  bothAxis: XYChartAxisInternal | undefined,
) {
  if (!bothAxis) {
    return false;
  }

  const rightIndex = axes.findIndex(
    (axis) => isRightAxis(axis) && !axis.hidden,
  );
  const leftIndex = axes.findIndex((axis) => isLeftAxis(axis) && !axis.hidden);
  const bothIndex = axes.findIndex((axis) => isBothAxis(axis) && !axis.hidden);

  const nonDefined = !leftAxis && !rightAxis;

  return (
    (nonDefined && bothAxis) ||
    ((bothIndex < leftIndex || leftIndex === -1) &&
      (bothIndex < rightIndex || rightIndex === -1))
  );
}

export function getVisibleAxes(axes: XYChartAxisInternal[]) {
  const topAxis = axes.find((axis) => isTopAxis(axis) && !axis.hidden);

  const bottomAxis = axes.find((axis) => isBottomAxis(axis) && !axis.hidden);

  const leftAxis = axes.find((axis) => isLeftAxis(axis) && !axis.hidden);

  const rightAxis = axes.find((axis) => isRightAxis(axis) && !axis.hidden);

  const verticalBothAxis = axes.find(
    (axis) => isXAxis(axis) && isBothAxis(axis) && !axis.hidden,
  );

  const horizontalBothAxis = axes.find(
    (axis) => isYAxis(axis) && isBothAxis(axis) && !axis.hidden,
  );

  const displayBothVertical = shouldDisplayBothVertical(
    axes,
    topAxis,
    bottomAxis,
    verticalBothAxis,
  );

  const displayBothHorizontal = shouldDisplayBothHorizontal(
    axes,
    leftAxis,
    rightAxis,
    horizontalBothAxis,
  );

  const visibleAxes: XYChartVisibleAxesConfig = {
    top: displayBothVertical ? verticalBothAxis : topAxis,
    bottom: displayBothVertical ? verticalBothAxis : bottomAxis,
    left: displayBothHorizontal ? horizontalBothAxis : leftAxis,
    right: displayBothHorizontal ? horizontalBothAxis : rightAxis,
  };

  return visibleAxes;
}
